import { memo } from 'react'
import { useScrollIntoView } from 'hooks/useScrollIntoView'

import PlaybackSpeedOption from './Value'
import { PLAYBACK_SPEED_OPTIONS } from '../../consts'

interface IProps {
  selectedValue: number | string
  handleValueClick: (value: number) => void
}

const PlaybackSpeedOptionList: React.FC<IProps> = ({
  selectedValue,
  handleValueClick
}) => {
  const { setNode } = useScrollIntoView()

  const getIsSelectedValue = (value: number) => value === selectedValue

  return (
    <>
      {PLAYBACK_SPEED_OPTIONS.map(value => (
        <PlaybackSpeedOption
          key={`${value}`}
          value={value}
          isSelected={getIsSelectedValue(value)}
          onClick={handleValueClick}
          setNode={setNode}
        />
      ))}
    </>
  )
}

export default memo(PlaybackSpeedOptionList)
